/**
 * SnackBarData
 * Provides configuration for how a snackbar will be shown.
 * @param message (required) The body text of the snackbar
 * @param buttonText (optional) The accompanying button text of the snackbar.
 * @param buttonCallback (optional, must be included if buttonText exists)
 *                       a function that will be called when the button is pressed.
 * @param duration (optional, default 3000) how long, in ms, for the snackbar to show.
 */
export class SnackBarData {
  message: string;
  buttonText?: string;
  buttonCallback?: () => void;

  duration = 3000;
  hasButton = false;

  constructor(
    message: string,
    buttonText?: string,
    buttonCallback?: () => void,
    duration?: number
  ) {
    this.message = message;

    if (!!duration) {
      this.duration = duration;
    }

    if (!!buttonText && !!buttonCallback) {
      this.hasButton = true;
      this.buttonText = buttonText;
      this.buttonCallback = buttonCallback;
    }
  }
}
